/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { Injectable, inject } from "@angular/core";
import {
	Router,
	type ActivatedRouteSnapshot,
	type CanActivate,
	type RouterStateSnapshot,
	type UrlTree,
} from "@angular/router";
import type { Observable } from "rxjs";
import { CbRoutesUtils } from "../@classes/routes/cb-routes-utils";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class CreateTenantGuard implements CanActivate {
	private readonly homeUrl = CbRoutesUtils.paths.w.home.path;
	private readonly router: Router = inject(Router);

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		const canCreateTenants = environment.canCreateTenants;

		if (!canCreateTenants) {
			this.router.navigate([this.homeUrl]);
			return false;
		}

		return true;
	}
}
